import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import aboutUs from "@/components/aboutUs"
import caseList from "@/components/case/caseList"
import caseDetail from "@/components/case/caseDetail"
import cooperation from "@/components/cooperation"
import teamBuildingDetail from '@/components/teamBuildingview/teamBuildingDetail'
import teamBuildingQuote from '@/components/teamBuildingview/teamBuildingQuote'
import teamBuilding from '@/components/teamBuildingView/teamBuilding'
import tbWorkBenchList from '@/components/teamBuildingView/tbWorkBenchList'
import internalTrainingList from '@/components/internalTraining/internalTrainingList'
import internalTrainingDetail from '@/components/internalTraining/internalTrainingDetail'
import annualMeetingPage from '@/components/annualMeeting/annualMeetingPage'
import annualMeetingDetail from '@/components/annualMeeting/annualMeetingDetail'
import annualMeetingConstructDetail from '@/components/annualMeeting/annualMeetingConstructDetail'
import themeList from '@/components/themeList'
import custom from '@/components/custom'
import store from '../vuex/store'
import { visitRecord } from '../router/api'
// import distributionDetail from "@/components/userview/distributionDetail"
Vue.use(Router)

const router = new Router({
  // mode:'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/teamBuilding',
      name: 'teamBuilding',
      component: teamBuilding
    },
    {
      path: '/tbWorkBenchList',
      name: 'tbWorkBenchList',
      component: tbWorkBenchList
    },
    {
      path: '/teamBuildingDetail',
      name: 'teamBuildingDetail',
      component: teamBuildingDetail
    },
    {
      path: '/teamBuildingQuote',
      name: 'teamBuildingQuote',
      component: teamBuildingQuote
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/themeList',
      name: 'themeList',
      component: themeList
    },
    {
      path: '/internalTrainingList',
      name: 'internalTrainingList',
      component: internalTrainingList
    },

    {
      path: '/internalTrainingDetail',
      name: 'internalTrainingDetail',
      component: internalTrainingDetail
    },
    {
      path: '/annualMeetingPage',
      name: 'annualMeetingPage',
      component: annualMeetingPage
    },
    {
      path: '/custom',
      name: 'custom',
      component: custom
    },
    {
      path: '/annualMeetingDetail',
      name: 'annualMeetingDetail',
      component: annualMeetingDetail
    },
    {
      path: '/annualMeetingConstructDetail',
      name: 'annualMeetingConstructDetail',
      component: annualMeetingConstructDetail
    },
    {
      path: '/caseList',
      name: 'caseList',
      component: caseList
    },
    {
      path: '/caseDetail',
      name: 'caseDetail',
      component: caseDetail
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation
    },

  ],


})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.name != 'caseDetail' || to.name != 'caseSchedule' || to.name != 'annualMeetingDetail' || to.name != 'teamBuildingDetail' || to.name != 'internalTrainingDetail') {
    document.title = "蓝星球团建~一站式服务平台"
  }
  store.commit("saveIsLoadingCity", true);
  store.dispatch("getInitSiteCityList");
  let isNextMethod = setInterval(() => {
    if (!store.state.isLoadingCity) {
      // 关闭定时器
      store.commit("clearIsNextMethod");
      if (
        to.fullPath.indexOf('home') != -1 || to.fullPath == "/"
        || to.fullPath.indexOf('teamBuilding') != -1
        || to.fullPath.indexOf('teamBuildingDetail') != -1
        || to.fullPath.indexOf('internalTrainingList') != -1
        || to.fullPath.indexOf('annualMeetingPage') != -1
        || to.fullPath.indexOf('caseList') != -1
      ) {
        visitRecord(to.fullPath)
      }
      // 页面跳转
      next();
    }
  }, 100);
  // 将定时器放入store
  store.commit("saveIsNextMethod", isNextMethod);
})

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js